//axiosInstance.js
//导入axios
import axios from 'axios'
import router from '../router/index'
import autoLogin from './autoLogin'
import store from '@/store'
//使用axios下面的create([config])方法创建axios实例，其中config参数为axios最基本的配置信息。
function myRequest(config, isGuestLogin) {
  const instance = axios.create({
    baseURL: '/apis', //请求后端数据的基本地址，自定义
    timeout: 200000, //请求超时设置，单位ms
  })
  /* 请求拦截 */
  instance.interceptors.request.use(
    (config) => {
      let token = sessionStorage.getItem('token')
      config.headers['Authorization'] = token
      return config
    },
    (err) => err
  )
  /* 响应拦截 */
  instance.interceptors.response.use(
    async (res) => {
      if (!res.data.success) {
        if(res.data.msg === 'TOVIP'){
          router.push('/myCenter?type=5')
        }else if(res.data.msg === 'TOLOGIN'){
          router.push('/login')
        }
        //判断code是否为5002:token为空 5003:无效token  以及其他code带具体接口时更改 ---需要自动登录
        if ([5002, 5003].includes(res.data.code)) {
          //个人中心只有个人账号才能看
          if (router.currentRoute.path.includes('myCenter')) {
            router.push('/')
          }
          if (isGuestLogin) {
            // store.commit('isCreatePage', false)
            // sessionStorage.setItem('token', '')
            autoLogin.myLogin()
          }
        } else if ([5004].includes(res.data.code)) {
          //无访问权限去登录页
          router.push('/login?redirect=' + encodeURIComponent(router.currentRoute.fullPath))
        }
      }
      return res.data
    },
    (err) => err
  )
  return instance(config)
}

export function request(url, data = {}, method = 'get', isGuestLogin = true) {
  if (method == 'get') {
    return myRequest(
      {
        method,
        url,
        params: data,
      },
      isGuestLogin
    )
  } else if (method == 'post') {
    return myRequest(
      {
        method,
        url,
        data,
      },
      isGuestLogin
    )
  }
}
